import React from 'react';
import feather from 'feather-icons';
import { css } from 'react-emotion';

export default (name, measureArray, myStyle) => {
  const featherString = feather.toSvg(name, { class: myStyle, 'width': measureArray[0], 'height': measureArray[1] })
  return (
    <div dangerouslySetInnerHTML={{__html: featherString}}></div>
  )
}



// WEBPACK FOOTER //
// ./src/utils/feather.js